import * as React from "react";

import {
  Box,
  Dialog,
  DialogContent,
  makeStyles,
  Theme,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { MopButton } from "client/components";
import { BankAccountForm } from "client/domain/FormBuilder/BankInformation";
import { useBranding, useTranslation } from "client/hooks";
import { BankFieldSetNames } from "client/lib/apt-merchant/src/fieldsets";

const useStyles = makeStyles((theme: Theme) => ({
  modalRoot: {
    maxWidth: "648px",
  },
  closeIcon: {
    margin: theme.spacing(3, 3, 1, 0),
    cursor: "pointer",
    transition: "all .2s ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
}));

export const ManualBankDialog: React.FC<{
  fieldSetName: BankFieldSetNames;
  updateToNextStep?: () => void;
  plaidEnabled: boolean;
}> = ({ fieldSetName, updateToNextStep, plaidEnabled }) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const t = useTranslation();

  const { brandKey } = useBranding();
  const isCash = brandKey === "CashApp";

  const handleOnSubmitSuccess = () => {
    if (updateToNextStep) {
      updateToNextStep();
    }
    setOpen(false);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="center" color="info.main">
        <MopButton
          mopVariant={isCash && !plaidEnabled ? "primary" : "secondary"}
          variant={isCash && plaidEnabled ? "text" : "contained"}
          fullWidth
          onClick={() => setOpen(true)}
          id={`Manual-Bank-${fieldSetName}`}
          data-testid={`Manual-Bank-${fieldSetName}`}
        >
          <strong>{t("uiAddBankManuallyLink")}</strong>
        </MopButton>
      </Box>
      <Dialog
        aria-describedby="add your bank manually modal"
        aria-labelledby="bank-account-modal"
        classes={{
          paper: classes.modalRoot,
        }}
        fullWidth
        maxWidth="md"
        onClose={() => setOpen(false)}
        open={open}
      >
        <Box pb={11}>
          <Box display="flex" justifyContent="flex-end">
            <CloseIcon
              className={classes.closeIcon}
              onClick={() => setOpen(false)}
            />
          </Box>
          <Box alignItems="center" display="flex" flexDirection="column">
            <Box mb={3.5}>
              <Typography variant="h6">
                <strong>{t("uiBankAccountModalHeading")}</strong>
              </Typography>
            </Box>
            <DialogContent>
              <BankAccountForm
                fieldSetName={fieldSetName}
                heading={
                  <Box mb={2}>
                    <Typography variant="body2">
                      {t("uiBankAccountManualFormHeading")}
                    </Typography>
                  </Box>
                }
                onSubmitSuccess={handleOnSubmitSuccess}
              />
            </DialogContent>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};
